<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    persistent
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab color="error" dark v-bind="attrs" v-on="on">
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title :class="colorClass" class="teal darken-3 white--text" dark>
        On The Way Inventory
        <!-- {{ UsersToken }} -->
        <v-spacer></v-spacer>

        <v-btn text icon @click="close" dark>
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-5">
        <!-- Inventory Categories -->

        <v-row class="justify-center">
          <v-col cols="12" md="4">
            <v-card :class="colorClass" class="darken-4 white--text">
              <v-card-title primary-title>
                Stock information
              </v-card-title>
              <v-card-text>
                <v-form ref="OntheWayForm" v-model="validBase">
                  <v-col cols="12">
                    <BaseDate
                      dark
                      :rules="rules.required"
                      v-model="Container.Date"
                    ></BaseDate>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      dark
                      outlined
                      :rules="[rules.required]"
                      :loading="loadCtgory"
                      :items="Suplier"
                      item-text="CostName"
                      item-value="_id"
                      v-model.trim="Container.SelectedSupp"
                      label="Sapplier"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      dark
                      outlined
                      clearable
                      chips
                      deletable-chips
                      small-chips
                      multiple
                      return-object
                      :rules="[rules.required]"
                      :loading="loadCtgory"
                      :items="Inventories"
                      item-value="_id"
                      item-text="AccountName"
                      v-model="InventoryName"
                      label="Category"
                    >
                      <template v-slot:prepend-item>
                        <BaseSellectAll
                          :selected="InventoryName"
                          :items="Inventories"
                          :toggle="toggleCateg"
                        ></BaseSellectAll>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :rules="[v => !!v || `Details is required`]"
                      name="Dtails"
                      label="Enter Details"
                      id="Details"
                      dark
                      outlined
                      v-model="Container.DetailsOrder"
                    ></v-text-field>
                  </v-col>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  v-if="validBase"
                  @click="GetInventories"
                  :loading="loaditem"
                  block
                  color="primary"
                  dark
                  >Search</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
          <!-- inventory qty and price -->
          <v-col v-if="items.length" cols="12" md="8">
            <v-form ref="BulkQtyTBLForm" v-model="valid">
              <v-data-table
                :caption="InventoryCab"
                :loading="loaditem"
                :search="search"
                :headers="headers"
                :items="items"
                show-select
                item-key="ItemID"
                v-model="ItemName"
              >
                <template #top>
                  <v-toolbar flat color="grey lighten-3">
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="mt-7"
                      dense
                      outlined
                      name="SearchFildname"
                      label="Search"
                      id="SearchFildId"
                      v-model="search"
                    ></v-text-field>
                  </v-toolbar>
                </template>
                <v-divider></v-divider>

                <template #[`item.qty`]="{item}">
                  <div class="mt-3 row">
                    <div class=" col-7">
                      <BaseNumInput
                        v-if="isSelected(item)"
                        :key="item.ItemID"
                        dense
                        :value="item.exp"
                        outlined
                        :rules="[QtyRule]"
                        :label="item.UnitType + ' QTY'"
                        v-model="item.exp"
                        @input="
                          v => {
                            item.exp = v;
                            item.Units = 0;
                          }
                        "
                      ></BaseNumInput>
                    </div>
                    <div class="col-5">
                      <v-text-field
                        type="number"
                        v-if="isSelected(item)"
                        :key="item.ItemID + 'Unite'"
                        :value="item.Units"
                        dense
                        @blur="e => Onblur(e, item)"
                        outlined
                        label="PCS QTY"
                        @input="v => OnUnitChange(item, v)"
                      ></v-text-field>
                    </div>
                  </div>
                </template>

                <template #[`item.price`]="{item}">
                  <div class="mt-3">
                    <BaseNumInput
                      v-if="isSelected(item)"
                      outlined
                      dense
                      :label="item.UnitType + ' Cost'"
                      v-model.number="item.unitPrice"
                    ></BaseNumInput>
                  </div>
                </template>
              </v-data-table>
            </v-form>
          </v-col>
        </v-row>

        <p class="font-weight-black mt-3 text-center" v-html="msgError"></p>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          @click="OnSupplierSave"
          :disabled="!ItemName.length || !valid"
          :loading="clicked"
          class="elevation-6"
          rounded
          :color="btnColor"
          dark
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  props: {
    OnFinish: { type: Function, required: true },
  },
  components: {
    // newInventory: () => import("./_ExpectedQty")
  },

  data() {
    return {
      ID: "",
      SuppURL: "/supplier",
      URL: "/AccCharts",
      Stock: "/stock",
      search: "",
      Suplier: [],
      validBase: false,
      valid: false,
      dialog: false,
      msgError: "",
      clicked: false,
      loadCtgory: false,
      loaditem: false,
      Inventories: [],
      InventoryName: [],
      SelectedInv: {},
      headers: [
        {
          text: "CATEGORY",
          align: "left",
          value: "AccountName",
          class: "grey lighten-3 ",
        },
        {
          text: "ITEM",
          value: "ItemName",
          class: "grey lighten-3 ",
        },
        {
          text: "QTY",
          value: "qty",
          sortable: true,
          align: "center",
          class: "grey lighten-3 ",
        },
        // {
        //   text: "COST",
        //   value: "cost",
        //   sortable: true,
        //   class: "grey lighten-3 "
        // },
        {
          text: "PRICE",
          value: "price",
          class: "grey lighten-3 ",
        },
      ],
      items: [],
      ItemName: [],
      Container: {
        Items: {},
        Date: "",
        SelectedSupp: "",
        DetailsOrder: "",
      },
      rules: {
        required: value => !!value || "Required.",
        items: value => !!value.length || "Required.",
        // ItemName
      },
    };
  },

  watch: {
    dialog(val) {
      if (val) {
        this.Container.Date = this.Current().date;
      }
    },
    // ItemName(val) {
    //   this.SelectedInv = val.reduce((gateg, inv) => {
    //     if (!gateg[inv.InvCateg])
    //       gateg[inv.InvCateg] = { categ: inv.InvCateg, items: [] };
    //     gateg[inv.InvCateg].items = [
    //       ...(gateg[inv.InvCateg].items || []),
    //       {
    //         ItemID: inv._id,
    //         ItemName: inv.InvName,
    //         UnitType: inv.UnitType,
    //         exp: 1,
    //         qty: 1,
    //         unitPrice: 1
    //       }
    //     ];
    //     return gateg;
    //   }, {});
    // },
    InventoryName() {
      this.items = [];
      this.ItemName = [];
    },
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    btnColor() {
      return this.UsersToken.UserBranch == "company"
        ? "teal darken-2"
        : "error";
    },
    InventoryCab() {
      return this.ItemName.length + "/" + this.items.length + " Selected";
    },
    colorClass() {
      return this.UsersToken.UserBranch == "company" ? "teal" : "grey";
    },
  },
  methods: {
    Onblur(e, item) {
      // e.target.value = item.Units;
      item.Units = Number(e.target.value) % item.UnitQty;
      console.log(e.target.value);
    },
    OnUnitChange(item, val) {
      if (isNaN(val)) return;
      // console.log(val);
      val = item.Units = Number(val);
      let temp = val / item.UnitQty;
      item.exp = parseInt(temp);
      // item.Units = Math.round((temp - item.exp) * item.UnitQty);
      // item.Units = val % item.UnitQty;
      // console.log(val % item.UnitQty);
      // console.log(item.Units);
      return item.Units;

      //  v-model="item.Units"
    },
    toggleCateg() {
      this.$nextTick(() => {
        if (this.Inventories.length === this.InventoryName.length) {
          this.InventoryName = [];
        } else {
          this.InventoryName = this.Inventories.slice();
        }
      });
    },

    close() {
      this.dialog = false;
      this.Container.Date = "";
      this.InventoryName = [];
      // this.$emit("input", false);
    },
    getReq(url) {
      return this.$store.dispatch("GET_ONLY", url);
    },
    getReByQuery(value) {
      return this.$store.dispatch("FIND_BY_VALUE", value);
    },
    loadCategories() {
      this.loadCtgory = true;
      axios
        .all([this.getReq(`${this.URL}/Category`), this.getReq(this.SuppURL)])
        .then(result => {
          // console.log(result);
          this.Inventories = result[0].data;
          this.Suplier = result[1].data;
          this.loadCtgory = false;
        })
        .catch(() => {
          this.loadCtgory = false;
        });
    },
    isSelected({ ItemID }) {
      return this.ItemName.find(item => item.ItemID == ItemID);
    },
    GetInventories() {
      this.msgError = "";
      if (!this.$refs.OntheWayForm.validate()) return;

      let ReqInv = {
        url: this.URL,
        query: {
          CategName: this.InventoryName.map(categ => categ._id),
        },
      };
      // console.log(ReqInv.query.CategName);
      this.loaditem = true;
      this.getReByQuery(ReqInv)
        .then(result => {
          this.loaditem = false;
          this.inventoris = [];
          this.items = result.data.map(inv => {
            return {
              AccountName: inv.AccountName,
              ItemID: inv._id,
              ItemName: inv.InvName,
              UnitType: inv.UnitType,
              UnitQty: inv.UnitQty,
              qty: 1,
              exp: 0,
              Units: 0,
              unitPrice: 0,
            };
          });
          // this.loadingItems = false;
        })
        .catch(() => {
          this.loaditem = false;
        });
    },
    OnSupplierSave() {
      this.msgError = "";
      if (
        this.$refs.OntheWayForm.validate() &&
        this.$refs.BulkQtyTBLForm.validate()
      ) {
        this.Container.Items = this.ItemName;
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.Stock + "/Ontheway",
            data: this.Container,
          })
          .then(result => {
            this.clicked = false;
            this.$refs.OntheWayForm.reset();
            // console.log(result);
            // this.AllSuppliers = result.data;
            this.OnFinish(result.data);
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },

    UnitRule(item) {
      return v => {
        if (!v && v != 0) return "Qty is required";
        let newVal = v.toString().replace(/,/g, "");
        if (parseFloat(newVal) - parseInt(newVal) !== 0)
          return "Decimal Qty not allowed";
        return (v >= 0 && v < item.UnitQty) || "Invalid Unit";
      };
    },
    QtyRule(v) {
      if (v == 0) return true;
      if (!v) return "Qty is required";
      let newVal = v.toString().replace(/,/g, "");
      if (parseFloat(newVal) - parseInt(newVal) !== 0)
        return "Decimal Qty not allowed";

      //   if (v && !isNaN(v.toString().replace(/,/g, "")))
      //     this.QtyItems = parseInt(v.toString().replace(/,/g, ""));
      return (newVal && newVal > 0) || `QTY ${v} is not allowed`;
    },
  },
  mounted() {
    this.loadCategories();
  },
};
</script>
